import { DatoCmsSignUp } from 'lib/datoCms/queries/getAllSignUpLabels';
import { PersonalDataLabel } from '../PersonalInfo';

export const getPersonalDataLabel = (label: DatoCmsSignUp): PersonalDataLabel => {
  return {
    titlePersonalData: label.titleSixthForm,
    descriptionPersonalData: label.descriptionSixthForm,
    descriptionPromoCode: label.descriptionPromoCode,
    name: label.name,
    placeholderName: label.placeholderName,
    surname: label.surname,
    placeholderSurname: label.placeholderSurname,
    gender: label.gender,
    genderValues: label.genderValues,
    county: label.county,
    city: label.city,
    fiscalCode: label.fiscalCode,
    address: label.address,
    placeholderAddress: label.placeholderAddress,
    addressNumber: label.addressNumber,
    residenceCounty: label.residenceCounty,
    residenceCity: label.residenceCity,
    zipCode: label.zipCode,
    labelCalcolaCodiceFiscale: label.labelCalcolaCodiceFiscale,
    birthday: label.birthday,
    spidTitle: label.spidTitle,
    externalState: label.externalState,
    spidDescription: label.spidDescription,
    addressDomicile: label.addressDomicile,
    addressNumberDomicile: label.addressNumberDomicile,
    provinceDomicile: label.provinceDomicile,
    sameAsDomicile: label.sameAsDomicile,
    zipCodeDomicile: label.zipCodeDomicile,
    cityDomicile: label.cityDomicile,
    placeholderAddressNumberDomicile: label.placeholderAddressNumberDomicile,
    placeholderDomicileAddress: label.placeholderDomicileAddress,
    placeholderZipCodeDomicile: label.placeholderZipCodeDomicile,
    spidEnabled: label.spidEnabled,
    nationality: label.nationality,
    birthNationality: label.birthNationality,
    externalResidential: label.externalResidential,
  };
};
